import {
  Component,
  OnInit,
  Inject,
  ChangeDetectionStrategy,
  ViewEncapsulation,
  OnDestroy,
  ChangeDetectorRef,
  Input,
  AfterViewInit,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material";
import { Observable, Subscription } from "rxjs";
import { map, tap } from "rxjs/operators";
import { CustomerModel } from "src/app/models/customer.model";
import { AddressService } from "src/app/services/address.service";
import { CustomersService } from "src/app/services/customer.service";
import { AddressDialogComponent } from "../address-dialog/address-dialog.component";
import { ReferralService } from "src/app/services/referral.service";
import { ToastrService } from 'ngx-toastr';


// // Material
// import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
// // RxJS
// import { Subscription, Observable } from 'rxjs';
// import { map, startWith } from 'rxjs/operators';
// // Services and Models
// import { CustomerModel, CustomersService } from '';
// import { AuthService } from '../../../../../core/auth';
// import { AddressService } from '../../../../../core/_base/crud';
// import { CustomDatePipe } from '../../../../../core/_base/layout/index'
// import { AddressDialogComponent } from '../address-dialog/address-dialog.component';
// import { MyreferralsService } from '../../../../../core/myreferrals/myreferrals.service'

@Component({
  // 	// tslint:disable-next-line:component-selector
  selector: "kt-customers-edit-dialog",
  templateUrl: "./customer-edit.dialog.component.html",
  styleUrls: ['./customer-edit.dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CustomerEditDialogComponent implements OnInit, AfterViewInit {
  // @Input() element: any;
  customer: CustomerModel;
  newcustomerForm: FormGroup;
  hasFormErrors: boolean = false;
  countryList = [];
  stateList = [];
  cityList = [];
  localityList = [];
  sourceList = [];
  stageList = [];
  typeList = [];
  parentCustomerList = [];
  territoryList = [];
  filteredOptions: Observable<string[]>;
  tagList = [];
  designationList: any = [];
  customFields = [];
  option = [];
  frontViewRemove: boolean = false;
  backViewRemove: boolean = false;
  viewLoading: boolean = false;
  isCustomer: boolean = true;
  sameMobileNo: string;
  currentUser: any;
  sameEmail: string;
  private componentSubscriptions: Subscription;
  data1: string;
  referralList: any;
  referralListArray: [];
  businessData: any;
  ReferredBy: any;
  CountryId: any
  StateId: any
  CityId: any
  buttonShow: boolean = true;
  userData: any;
  filterCountryList = [];
  filterStateList = [];
  filterCityList = [];
  filterLocalityList = [];
  @Input() customerId: number;
  @Input() referralListdata: any[];
  @Input() referByCode: string;
  @Input() longitude : any;
  @Input() latitude : any;

  constructor(
    public dialogRef: MatDialogRef<CustomerEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private referralService: ReferralService,
    private toastr: ToastrService,
    private ref: ChangeDetectorRef,
    private addService: AddressService,
    private customersService: CustomersService,
    // private customDatePipe: CustomDatePipe,
    private dialog: MatDialog,
    // private myreferralsService: MyreferralsService,
    private addressService: AddressService
  ) { }

  ngOnInit() {
    this.createForm();
    this.getCountryList();
    // this.getSourceList();
    console.log(this.data)
  }

  ngAfterViewInit() {
    // console.log(this.element); // should output the `element` data
  }

  openMap() {
    let address = this.newcustomerForm.controls["Address"].value;
    const dialogRef = this.dialog.open(AddressDialogComponent, {
      width: "550px",
      data: {
        address: address,
        action: "",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (!result) return;
      this.newcustomerForm.controls["Address"].patchValue(result.res);
      this.longitude = result.longitude
      this.latitude = result.latitude
    });
  }

  createForm() {
    this.newcustomerForm = this.fb.group({
      LeadName: [
        "",
        Validators.compose([Validators.required, Validators.maxLength(200)]),
      ],
      RefNo: ["", Validators.compose([Validators.maxLength(200)])],
      PersonName: [
        "",
        Validators.compose([
          Validators.maxLength(200),
          Validators.pattern("^[a-zA-Z][a-zA-Z-' ]*[a-zA-Z ]$"),
        ]),
      ],
      MobileNo: ["", Validators.compose([Validators.maxLength(15)])],
      ContactNo: ["", Validators.compose([Validators.maxLength(15)])],
      Email: [
        "",
        Validators.compose([Validators.email, Validators.maxLength(100)]),
      ],
      PersonDesignation: [
        "",
        Validators.compose([
          Validators.maxLength(200),
          Validators.pattern("^[a-zA-Z][a-zA-Z-' ]*[a-zA-Z ]$"),
        ]),
      ],
      Address: ["", Validators.compose([Validators.maxLength(300)])],
      CountryId: [""],
      StateId: [""],
      CityId: [""],
      LocalityId: [""],
      PinCode: ["", Validators.compose([Validators.maxLength(10)])],
    });
    // this.newcustomerForm.patchValue(this.data)
    if (this.data.action === 'view') {
      this.userData = this.data.userData;
      this.newcustomerForm.patchValue({
        LeadName: this.userData.LeadName,
        RefNo: this.userData.RefNo,
        PersonName: this.userData.PersonName,
        MobileNo: this.userData.MobileNo,
        ContactNo: this.userData.ContactNo,
        Email: this.userData.Email,
        PersonDesignation: this.userData.PersonDesignation,
        Address: this.userData.Address,
        CountryId: this.userData.CountryId,
        StateId: this.userData.StateId,
        CityId: this.userData.CityId,
        LocalityId: this.userData.LocalityId,
        PinCode: this.userData.PinCode,
      })
      this.newcustomerForm.disable({ onlySelf: true })
      this.buttonShow = false;
    }
  }


  prepareCustomer(): any {
    // const customValue = this.newcustomerForm.controls['Customfields'].value
    // // for (let i = 0; i < customValue.length; i++) {
    // // 	let tempArray = [];
    // // 	if (typeof customValue[i].OptionId == 'number' && customValue[i].OptionId != null) {
    // // 		tempArray.push(customValue[i].OptionId)
    // // 		customValue[i].OptionId = tempArray
    // // 	}
    // // 	// if (customValue[i].FieldType == 'Date' && customValue[i].Value) {
    // // 	// 	customValue[i].Value = this.customDatePipe.transform(customValue[i].Value, 0, 'MM/dd/yyyy')
    // // 	// }
    // // }

    const controls = this.newcustomerForm.controls;
    const _customer = new CustomerModel();
    // _customer.LeadId = this.customer.Id || '';
    _customer.LeadId = '';
    _customer.Name = '';
    // _customer.id = controls['id'].value;
    _customer.LeadName = controls["LeadName"].value;
    _customer.RefNo = controls["RefNo"].value;
    // _customer.ReferredBy = controls['ReferredBy'].value;
    _customer.PersonName = controls["PersonName"].value;
    _customer.MobileNo = controls["MobileNo"].value;
    _customer.ContactNo = controls["ContactNo"].value;
    _customer.Email = controls["Email"].value;
    _customer.PersonDesignation = controls["PersonDesignation"].value;
    _customer.Address = controls["Address"].value;
    _customer.CountryId = controls["CountryId"].value || 0;
    _customer.StateId = controls["StateId"].value || 0;
    _customer.CityId = controls["CityId"].value || 0;
    _customer.LocalityId = controls["LocalityId"].value || 0;
    _customer.PinCode = controls["PinCode"].value;
    _customer.Latitude = this.latitude;
    _customer.Longitude = this.longitude;
    return _customer;
  }


  onSubmit() {

    this.hasFormErrors = false;
    const controls = this.newcustomerForm.controls;

    if (this.newcustomerForm.invalid) {
      Object.keys(controls).forEach((controlName) =>
        controls[controlName].markAsTouched()
      );

      this.hasFormErrors = true;
      return;
    }
    const referralAddLead = this.prepareCustomer();
    this.AddLead(referralAddLead);
    // const _customer = new CustomerModel();
    // _customer.LeadId = '';
    // _customer.LeadName = controls["LeadName"].value;
    // _customer.Name = '';
    // _customer.RefNo = controls["RefNo"].value;
    // _customer.PersonName = controls["PersonName"].value;
    // _customer.MobileNo = controls["MobileNo"].value;
    // _customer.ContactNo = controls["ContactNo"].value;
    // _customer.Email = controls["Email"].value;
    // _customer.PersonDesignation = controls["PersonDesignation"].value;
    // _customer.Address = controls["Address"].value;
    // _customer.CountryId = controls["CountryId"].value || 0;
    // _customer.StateId = controls["StateId"].value || 0;
    // _customer.CityId = controls["CityId"].value || 0;
    // _customer.LocalityId = controls["LocalityId"].value || 0;
    // _customer.PinCode = controls["PinCode"].value;
  }

  AddLead(referralAddLead: any) {
    this.referralService.getReferralAddLead(referralAddLead)
      .pipe(
        map((res) => {
          console.log("API Response:", res);
          if (!res) {  // Check if res is null or undefined
            console.error("Error: API response is null or undefined");
            this.toastr.error("Unexpected API response");
            return;
          }
          if (res.Status == 200) {
            this.toastr.success('Lead Added Successfully');
            this.dialogRef.close(res.Status);
            console.log("res", res);
          }
          else if (res.Status == 417) {
            this.toastr.error(res.Message);
          }
        })
      ).subscribe((res) => console.log(res));
  }

  getCountryList() {
    this.addService.getCountry().pipe(map((res) => {
      if (res) {
        this.countryList = res;
        this.filterCountryList = res;
        if (this.data.action === 'view') {
          this.newcustomerForm.get("CountryId").setValue(this.userData.CountryId);
          this.getStateList();
        }
      }
    })
    ).subscribe();
  }

  getStateList() {
    let countryId = this.newcustomerForm.get('CountryId').value;
    this.addressService.getState(countryId).pipe(map((res) => {
      if (res) {
        this.stateList = res;
        this.filterStateList = res;
        if (this.data.action === 'view') {
          this.newcustomerForm.get("StateId").setValue(this.userData.StateId);
          this.getCityList();
        }
      }
    })
    ).subscribe();
  }

  getCityList() {
    let StateId = this.newcustomerForm.get('StateId').value;
    this.addressService.getCity(StateId).pipe(map((res) => {
      if (res) {
        this.cityList = res;
        this.filterCityList = res;
        if (this.data.action === 'view') {
          this.newcustomerForm.get("CityId").setValue(this.userData.CityId);
          this.getLocalityList();
        }
      }
    })
    ).subscribe();
  }

  getLocalityList() {
    let CityId = this.newcustomerForm.get('CityId').value;
    this.addressService.getLocality(CityId).pipe(map((res) => {
      if (res) {
        this.localityList = res;
        this.filterLocalityList = res;
        if (this.data.action === 'view') {
          this.newcustomerForm.get("LocalityId").setValue(this.userData.LocalityId);
        }
      }
    })
    ).subscribe();
  }

  filterValueCountry(event) {
    this.filterCountryList = this.countryList.filter(res => { return res.Name.toLowerCase().startsWith(event.toLowerCase()) })
  }
  filterValueState(event) {
    this.filterStateList = this.stateList.filter(res => { return res.Name.toLowerCase().startsWith(event.toLowerCase()) })
  }
  filterValueCity(event) {
    this.filterCityList = this.cityList.filter(res => { return res.Name.toLowerCase().startsWith(event.toLowerCase()) })
  }
  filterValueLocality(event) {
    this.filterLocalityList = this.localityList.filter(res => { return res.LocalityName.toLowerCase().startsWith(event.toLowerCase()) })
  }


}
